import instance from '@/services/repository';

const resource = '/eventlogs';

export default {
    lookup(payload: IEventLogQuery) {
        return instance.post<IEventLog[]>(`${resource}/lookup`, payload);
    },
};
